// JobType.js
const JobType = {
  SOFTWARE_ENGINEER_FULL_TIME: 1,
  SOFTWARE_ENGINEER_INTERNSHIP: 2,
  PRODUCT_FULL_TIME: 3,
  PRODUCT_INTERNSHIP: 4,
  DATA_SCIENTIST_FULL_TIME: 5,
  DATA_SCIENTIST_INTERNSHIP: 6,
};

const JobTypeTitle = {
  1: "Software Engineer Full-time Openings",
  2: "Software Engineer Internship Openings",
  3: "Product Manager Full-time Openings",
  4: "Product Manager Internship Openings",
  5: "Data Scientist Full-time Openings",
  6: "Data Scientist Internship Openings",
};

const JobTypeDescription = {
  1: "Entry-Level Software Engineering roles in leading tech companies, updated every 12 hours so that you don't miss out on existing opportunities.",
  2: "Latest SWE Internships opportunities for aspiring Software Engineers in the tech world, updated every 12 hours to bring you the freshest openings.",
  3: "Full-time Product Manager positions at top tech firms, refreshed bi-daily to help you find your ideal role.",
  4: "Most recent internship openings for upcoming Product Managers in the dynamic tech industry, updated twice daily for the newest opportunities.",
  5: "Dive into the world of Data Science with full-time roles in renowned tech firms.",
  6: "Embark on your Data Science journey with internships at leading tech companies.",
};

export { JobType, JobTypeTitle, JobTypeDescription };
